
// src/web/components/group-settings-page.jsx

import React from 'react'
import {
  SettingsPage,
  SettingsPanel,
} from './settings-page'
import connect from '../../connects/division-settings-page.js'
import DivisionBasicSetting from './division-basic-setting-panel.jsx'
import DivisionGroupManagementPanel from './division-group-management-panel.jsx'
import DivisionExportPanel from './division-export-panel.jsx'
import DivisionDeletePanel from './division-delete-panel.jsx'

class DivisionSettingsPage extends React.Component {
  render() {
    const {
      t,
      user,
      active,
      onClose ,
      name,
      division
    } = this.props
    return (
      <SettingsPage title={t('label:Section settings')}
          active={active}
          onCloseDialog={onClose}
          name="division_setting"
          initialName="members" >
        <SettingsPanel name="profile"
            params={{ division: division }}
            label={t('label:基本設定')}
            icon="group_work"
            component={DivisionBasicSetting}
          />
        <SettingsPanel name="members"
            params={{ division: division }}
            label={t('label:Group management')}
            icon="people"
            division={division}
            component={DivisionGroupManagementPanel} />
        <SettingsPanel name="remind"
            params={{ division: division }}
            label={t('label:Download')}
            icon="cloud_download"
            component={DivisionExportPanel} />
        <SettingsPanel name="templates"
            params={{ division: division }}
            label={t('label:Move to trash')}
            icon="delete"
            division={division}
            component={DivisionDeletePanel} />
      </SettingsPage>
    )
  }
}

export const RawDivisionSettingsPage = DivisionSettingsPage
export default connect(DivisionSettingsPage)



// WEBPACK FOOTER //
// ./src/web/components/division-settings-page.jsx